import { render, staticRenderFns } from "./PaperStrategy.vue?vue&type=template&id=09aab3fc&scoped=true"
import script from "./PaperStrategy.vue?vue&type=script&lang=js"
export * from "./PaperStrategy.vue?vue&type=script&lang=js"
import style0 from "./PaperStrategy.vue?vue&type=style&index=0&id=09aab3fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aab3fc",
  null
  
)

export default component.exports